import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import * as userSettingsActions from "../../../users/actions/userSettings";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./SaveTag.css";

import Icon from "../Icon";

class SaveTag extends Component {
  constructor() {
    super();

    this.saveStory = this.saveStory.bind(this);
  }

  saveStory() {
    // If we are not logged in, open the auth drawer
    if (!this.props.authDrawer.loggedIn) {
      this.props.authDrawerActions.changeStep(authDrawerConstants.SIGNIN);
      return this.props.authDrawerActions.toggleAuthDrawer(true);
    }

    const savedStories = this.props.userSettings.data.profileInfo.savedStoryIds;

    // Save a story if not already saved
    if (savedStories && savedStories.indexOf(this.props.storyId) < 0) {
      const newSavedStories = savedStories.concat(this.props.storyId);

      this.props.userSettingsActions.submitSavedStories(newSavedStories);
    }

    // Remove a saved story if previously saved
    if (savedStories && savedStories.indexOf(this.props.storyId) >= 0) {
      const newSavedStories = savedStories.filter(savedStory => {
        return savedStory !== this.props.storyId;
      });

      this.props.userSettingsActions.submitSavedStories(newSavedStories);
    }
  }

  render() {
    const saved =
      this.props.userSettings.data.profileInfo.savedStoryIds.indexOf(
        this.props.storyId
      ) >= 0;

    return (
      <div
        onClick={this.saveStory}
        className={classNames(
          styles.root,
          this.props.absolute ? styles.absolute : {}
        )}
      >
        <span className={classNames(styles.save, { [styles.saved]: saved })}>
          Save
          {saved && "d"}
        </span>
        <Icon
          name="save"
          description="Save story"
          className={classNames(styles.icon, saved ? styles.saved : {})}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userSettings: state.userSettings,
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

SaveTag.propTypes = {
  absolute: PropTypes.bool,
  storyId: PropTypes.string.isRequired,
  stream: PropTypes.string,
  userSettings: PropTypes.shape({
    data: PropTypes.shape({
      profileInfo: PropTypes.shape({
        savedStoryIds: PropTypes.array.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  authDrawer: PropTypes.shape({
    loggedIn: PropTypes.bool,
  }).isRequired,
  userSettingsActions: PropTypes.shape({
    submitSavedStories: PropTypes.func.isRequired,
  }).isRequired,
  authDrawerActions: PropTypes.shape({
    changeStep: PropTypes.func.isRequired,
    toggleAuthDrawer: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveTag);
